export default __webpack_public_path__ + "static/media/bepaid_logos_dt.f5426a2c.png";